import { AppRoutes } from "@/routes/config";
import { createUrlWithParams } from "@/utils/url";

const CENTER_URL = process.env.REACT_APP_CENTER_URL;

export const POST_LOGIN_REDIRECT_KEY = "post-login-redirect";

/** Center (account provider) pages that this app links out to for account-level actions. */
export const CENTER_ROUTES = {
  userSettingDetail: "/user-setting/detail",
} as const;

const buildCenterUrl = (path: string): string => `${(CENTER_URL || "").replace(/\/+$/, "")}${path}`;

/** Opens a center page in a new tab; account-level actions (change email/password) live on the center. */
export const openCenterPage = (path: string): void => {
  // Without a configured center origin, buildCenterUrl would yield a relative path and open the
  // account's own origin — skip instead of navigating to the wrong app.
  if (!CENTER_URL) return;
  window.open(buildCenterUrl(path), "_blank", "noopener,noreferrer");
};

export const redirectToLogin = (): void => {
  if (window.location.pathname === AppRoutes.login) {
    window.location.replace(AppRoutes.login);
    return;
  }

  const redirectUrl = `${window.location.pathname}${window.location.search}`;
  window.location.replace(createUrlWithParams(AppRoutes.login, { redirectUrl }));
};

export const redirectToCenter = ({ replace = false }: { replace?: boolean } = {}): void => {
  const url = CENTER_URL || "/";
  if (replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
};
